
























































































































import { Component, Mixins } from "vue-property-decorator";
import { mapState } from "vuex";

// Mixins
import { FilteringSortingTableStore } from "@/mixins/tableWithFilteringAndSortingStore";

// Enums
import { DataModules } from "@/store/modules/data";

// Types
import { IFilter } from "@/models/tables";
import { FilterOperators, FilterTypes } from "@/data/table";
import { IBrand } from "@/models/brands";

@Component({
  computed: {
    ...mapState({
      brandId: (state: any) => state.auth.admin.brandId
    })
  }
})
export default class BrandsTable extends Mixins(FilteringSortingTableStore) {
  // :getters
  public brandId!: IBrand["id"];

  public filters: IFilter[] = [
    {
      key: "name",
      label: this.$t("_.name"),
      type: FilterTypes.STRING,
      operator: FilterOperators.CONTAINS
    },
    {
      key: "code",
      label: this.$t("_.code"),
      type: FilterTypes.STRING,
      operator: FilterOperators.CONTAINS
    },
    {
      key: "created_at",
      label: this.$t("_.created"),
      type: FilterTypes.DATE,
      operator: FilterOperators.EQUAL
    }
  ];

  public dataModule: string = DataModules.BRANDS;

  public created() {
    if (this.$userCan("list_brands")) {
      this.getData();
    }
  }

  public reloadData() {
    this.getData({ ignoreStored: true });
  }

  public async openDeleteBrandConfirmModal(brandId: IBrand["id"]) {
    const confirm = await this.$store.dispatch("ui/open/confirmModal", {
      config: {
        props: {
          autoClose: false,
          confirmButtonText: this.$t("_action.delete"),
          message: this.$t("_sentence.delete_confirmation", {
            object: (this.$t("_.brand") as string).toLowerCase()
          })
        },
        events: {
          confirmed: async () => {
            try {
              await this.deleteBrand(brandId);
              this.reloadData();
            } catch (error) {
              this.$store.dispatch("api/handleError", error);
            } finally {
              confirm.close();
            }
          }
        }
      }
    });
  }

  public async deleteBrand(brandId: IBrand["id"]) {
    return this.$store.dispatch("data/brands/remove", brandId);
  }

  public manageBrand(id: IBrand["id"], name: string): void {
    this.$router
      .push({
        name: "adminBrand",
        params: {
          id,
          name,
          redirect: "/admin/settings/general"
        }
      })
      // https://github.com/vuejs/vue-router/issues/2881#issuecomment-520554378
      .catch(() => ({}));
  }
}
